import React, { useState, useRef, useEffect } from "react";
import "./Crousal.css";
import selectedIcon from "./selectedIcon.svg";
import unselectedIcon from "./unselectedIcon.svg";
import prev from "./prev.svg";
import next from "./next.svg";
import iconPlus from "../../Images/IconPlus.svg";
import iconMinus from "../../Images/IconMinus.svg";
import { createPortal } from "react-dom";

const Crousal = (props) => {
    const { item } = props;
    let cleanData = (() => {
        try {
            return JSON.parse(item?.text);
        } catch (e) {
            return item?.text;
        }
    })();
    const [selectedBox, setSelectedBox] = useState(null);

    // References for carousel and arrows
    const carouselRef = useRef(null);
    const [showPrevArrow, setShowPrevArrow] = useState(false);
    const [showNextArrow, setShowNextArrow] = useState(true);
    const [isOffersRevamp , setIsOffersRevamp]  = useState(cleanData?.[0]?.isOffersRevamp);
    const [showPitch, setShowPitch] = useState(true);
    const [popupContent, setPopupContent] = useState(null);

    const [tooltip, setTooltip] = useState({ text: "", visible: false, position: { x: 0, y: 0 } });

    const handleViewClick = (value, e) => {
        e.stopPropagation();
      
        const pitchKey = Object.keys(value).find((k) => k !== "pop");
        const pitchText = value[pitchKey];
      
        const rect = e.target.getBoundingClientRect();
      
        setTooltip({
          text: pitchText,
          visible: true,
          position: {
            // Place tooltip exactly below “View” button
            x: rect.left + rect.width / 2 + window.scrollX,
            y: rect.bottom + window.scrollY + 8, // 8px gap below button
          },
        });
      
        // Optional: auto-hide after 5s
        setTimeout(() => {
          setTooltip({ text: "", visible: false, position: { x: 0, y: 0 } });
        }, 60000);
      };
      
      
       

        const Modal = ({ children, onClose }) => {
            const ref = useRef();
          
            const handleClickInside = (e) => {
              e.stopPropagation();
            };
          
            return createPortal(
              <div className="filter-overlay" onClick={onClose}>
                <div style={{width : '50%'}} className="filter-dropdown-modal" ref={ref} onClick={handleClickInside}>
                  {children}
                </div>
              </div>,
              document.body
            );
          };
      
        
          const handleClosePopup = () => {
            setPopupContent(null);
          };
  
     
 


    const handleBoxClick = (index) => {
        setSelectedBox(index);
        props?.setErrors((prevErrors) => ({
            ...prevErrors,
            [props?.index]: { key1: cleanData[index]?.title, displayName: cleanData[index]?.title },
        }));
        localStorage.setItem("inputBoxValue", JSON.stringify({ key1: cleanData[index]?.title }));
    };

    // Scroll handler
    const handleScroll = () => {
        const carousel = carouselRef.current;
        const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
        setShowPrevArrow(carousel.scrollLeft > 0);
        setShowNextArrow(carousel.scrollLeft < maxScrollLeft);
    };

    // Arrow click handlers
    const scrollCarousel = (direction) => {
        const carousel = carouselRef.current;
        carousel.scrollBy({ left: direction === "next" ? 200 : -200, behavior: "smooth" });
    };

    useEffect(() => {
        const carousel = carouselRef.current;
        carousel.addEventListener("scroll", handleScroll);
        return () => carousel.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className="carousel-container ">
            {showPrevArrow && cleanData?.length > 1 && (
                <img src={prev} alt="Previous" className="arrow prev" onClick={() => scrollCarousel("prev")} />
            )}
            {showNextArrow && cleanData?.length > 1 && (
                <img src={next} alt="Next" className="arrow next" onClick={() => scrollCarousel("next")} />
            )}

            <div className="carousel action-tab" ref={carouselRef}>
                {cleanData?.map((val, index) => {
                    const isSelected = selectedBox === index;
                    const { data } = val;
                    let cardType = val?.data?.cardType
                    let offerName = val?.data?.offerName
                    let isRecharge = val?.isRechargeFlow
                    let isFlexiOffer = val?.isFlexiOfferFlow
                    let offerScript = val?.data?.offerScript
                    let imageLink = val?.imageLink;
                    console.log("isRecharge", isRecharge + " imageLink: ", imageLink)

                    return (
                        <div
                            key={index}
                            className={`box-x ${isSelected ? "selected" : ""}`}
                            style={{ height: '100%' }}
                            onClick={() => handleBoxClick(index)}
                        >
                            <div className="box-item ">
                                <img
                                    src={isSelected ? selectedIcon : unselectedIcon}
                                    alt={isSelected ? "Selected" : "Unselected"}
                                    style={{ left: props.showMaximumChat && '45%', width: !props.showMaximumChat && '220px' }}
                                    className="selection-icon"
                                />
                                {(cardType === "offer" || isRecharge) && offerName && !isOffersRevamp &&(
                                    <div className="offer-title" style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "10px", margin: '18px', padding: '10px', border: '1px solid lightgray', borderRadius: '10px' }}>
                                        {offerName}
                                    </div>
                                )}
                                {isFlexiOffer && offerName && !isOffersRevamp &&(
                                    <div className="offer-title" style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "10px", margin: '18px', padding: '10px', border: '1px solid lightgray', borderRadius: '10px' }}>
                                        {offerName}
                                    </div>
                                )}
                                <table
                                    style={{
                                        border: "1px solid #ccc",
                                        borderCollapse: "collapse",
                                        width: "100%",
                                        marginTop: "12px",
                                        backgroundColor: "#ffffff",
                                        marginBottom: '20px'
                                    }}
                                   
                                >
                                    <tbody>
                                    {/* Image rendering stays same */}
                                        {isRecharge && imageLink && (
                                            <div
                                            style={{
                                                alignItems: "center",
                                                width: "125%",
                                                justifyContent: "center",
                                                display: "flex",
                                                margin: "5px 0px",
                                            }}
                                            >
                                            <img
                                                alt={offerName}
                                                src={imageLink}
                                                width={props?.showMaximumChat ? 240 : 200}
                                                height={props?.showMaximumChat ? 240 : 200}
                                            />
                                            </div>
                                        )}

                                        {isRecharge && offerScript && (
                                            <tr>
                                            <td colSpan="2" style={{ fontWeight: "400", textAlign: "justify" }}>
                                                <span className="A3f"  dangerouslySetInnerHTML={{ __html: offerScript }} />
                                            </td>
                                            </tr>
                                        )}

                                        {isFlexiOffer && imageLink && (
                                            <div
                                            style={{
                                                alignItems: "center",
                                                width: "125%",
                                                justifyContent: "center",
                                                display: "flex",
                                                margin: "5px 0px",
                                            }}
                                            >
                                            <img
                                                alt={offerName}
                                                src={imageLink}
                                                width={props?.showMaximumChat ? 240 : 200}
                                                height={props?.showMaximumChat ? 240 : 200}
                                            />
                                            </div>
                                        )}

                                        {isFlexiOffer && offerScript && (
                                            <tr>
                                            <td colSpan="2" style={{ fontWeight: "400", textAlign: "justify" }}>
                                                <span className="A3f"  dangerouslySetInnerHTML={{ __html: offerScript }} />
                                            </td>
                                            </tr>
                                        )}

                                        {/* Now switch table layout based on isOffersRevamp */}
                                        {isOffersRevamp ? (
                                            <>
                                            <tr>
                                                <th
                                                colSpan="100%"
                                                style={{
                                                    backgroundColor: "#d733a6",
                                                    color: "#fff",
                                                    textAlign: "center",
                                                    padding: "10px",
                                                    fontWeight: "600",
                                                    fontSize : '14px'
                                                }}
                                                className="A3f"
                                                >
                                                {data?.offerName || "Offer Details"}
                                                </th>
                                            </tr>
                                            <tr className="A3f">
                                                {Object.entries(data)
                                                    .filter(
                                                    ([key]) =>
                                                        key !== "title" &&
                                                        key !== "offerName" &&
                                                        key !== "cardType" &&
                                                        key !== "agentPitch" &&
                                                        key !== "offerScript" &&
                                                        !(isRecharge && key === "offerScript") &&
                                                        !(isFlexiOffer && key === "offerScript")
                                                    )
                                                    .map(([key, value]) => {
                                                    // If value is an object, show first value instead of key
                                                    let displayText;

                                                    if (typeof value === "object" && value !== null) {
                                                      if (value.pop === true) {
                                                        // get first key of the object 
                                                        const firstKey = Object.keys(value).find(k => k !== "pop");
                                                        displayText = firstKey.charAt(0).toUpperCase() + firstKey.slice(1) || "Pitch View";
                                                      } else {
                                                        displayText = "Pitch View";
                                                      }
                                                    } else {
                                                      displayText = key.charAt(0).toUpperCase() + key.slice(1);
                                                    }
                                                    return (
                                                        <th
                                                        key={key}
                                                        style={{
                                                            color: "#000",
                                                            padding: "8px",
                                                            fontWeight: "600",
                                                            textAlign: "center",
                                                            fontSize: "14px",
                                                        }}
                                                        className="A3f"
                                                        >
                                                        {displayText}
                                                        </th>
                                                    );
                                                    })}
                                                </tr>

                                            <tr className="A3f">
                                                {Object.entries(data)
                                                .filter(
                                                    ([key]) =>
                                                    key !== "title" &&
                                                    key !== "offerName" &&
                                                    key !== "cardType" &&
                                                    key !== "agentPitch" &&
                                                    key !== "offerScript" &&
                                                    !(isRecharge && key === "offerScript") &&
                                                    !(isFlexiOffer && key === "offerScript")
                                                )
                                                .map(([key, value]) => {
                                                    const displayText =
                                                        typeof value === "object" && value !== null
                                                        ? "View" // get first value of object
                                                        : value.charAt(0).toUpperCase() + value.slice(1);
                                                   return (
                                                    <td
                                                    key={key}
                                                    style={{
                                                        backgroundColor: "#f9f0fa",
                                                        textAlign: "center",
                                                        padding: "8px",
                                                        fontSize : '12px'
                                                    }}
                                                    >
                                                    {typeof value === "object" && value !== null && value.pop ? (
                                                        <span
                                                            onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleViewClick(value ,e);
                                                            }}
                                                            style={{
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                            cursor: "pointer",
                                                            }}
                                                        >
                                                            {displayText}
                                                        </span>
                                                        ) : (
                                                        <span>{displayText}</span>
                                                        )}
                                                    </td>
                                                )
                                                })}
                                            </tr>
                                            </>
                                        ) : (
                                            /* keep your vertical version exactly as it is */
                                            <>
                                            {data &&
                                                Object.entries(data)
                                                .filter(
                                                    ([key]) =>
                                                    key !== "title" &&
                                                    key !== "offerName" &&
                                                    key !== "cardType" &&
                                                    key !== "agentPitch" &&
                                                    key !== "offerScript" &&
                                                    !(isRecharge && key === "offerScript") &&
                                                    !(isFlexiOffer && key === "offerScript")
                                                )
                                                .map(([key, value], idx, array) => (
                                                    <tr
                                                    className="table-head A3f"
                                                    key={key}
                                                    style={{
                                                        borderTopLeftRadius: idx === 0 ? "10px" : "0",
                                                        borderTopRightRadius: idx === 0 ? "10px" : "0",
                                                        borderBottomLeftRadius:
                                                        idx === array.length - 1 ? "10px" : "0",
                                                        borderBottomRightRadius:
                                                        idx === array.length - 1 ? "10px" : "0",
                                                    }}
                                                    >
                                                    <td
                                                  className="call-logs-table"                                                       style={{
                                                        borderTopLeftRadius: idx === 0 ? "10px" : "0",
                                                        borderBottomLeftRadius: idx === array.length - 1 ? "10px" : "0",
                                                        }}
                                                    >
                                                        <strong>
                                                        {key.charAt(0).toUpperCase() + key.slice(1)}
                                                        </strong>
                                                    </td>
                                                    <td
                                                    className="call-logs-table"
                                                        style={{
                                                        fontWeight: "400",
                                                        borderTopRightRadius: idx === 0 ? "10px" : "0",
                                                        borderBottomRightRadius:
                                                            idx === array.length - 1 ? "10px" : "0",
                                                        }}
                                                    >
                                                        {value}
                                                    </td>
                                                    </tr>
                                                ))}
                                            </>
                                        )}
                                        </tbody>




                                </table>
                                {val?.data?.agentPitch && (
                                    <div className="A3f">
                                        <div onClick={(e) => {
                                            e.stopPropagation(); 
                                            setShowPitch(!showPitch);
                                        }}style={{ cursor: "pointer" }}>
                                        
                                        Agent Pitch
                                        <img
                                            src={showPitch ? iconMinus : iconPlus}
                                            alt="toggle"
                                            style={{ width: 18, height: 18, marginLeft: 10 , top : 3 , position : 'relative' }}
                                        />
                                        </div>

                                        {showPitch && (
                                            <div
                                                style={{ margin: '10px' }}
                                                dangerouslySetInnerHTML={{ __html: `${val?.data?.agentPitch}` }}
                                            />
                                            )}

                                    </div>
                                    )}
                            </div>
                        </div>
                    );
                })}

            </div>
            {tooltip.visible && (
  <div className="tooltip-note" style={{ top: "50%", left: "50%"  , width :'100%'}}>
    {/* Close button */}
    <button
      className="tooltip-close-btn"
      onClick={() =>
        setTooltip({ text: "", visible: false, position: { x: 0, y: 0 } })
      }
    >
      &times;
    </button>

    <div style={{color : 'white'}} className="A3f" dangerouslySetInnerHTML={{ __html: tooltip.text }} />
  </div>
)}



        </div>
    );
};

export default Crousal;
